import React from 'react';
import { compose, pure } from 'recompose';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';

const styles = {
  button: {
    margin: '5px 5px'
  }
};

const enhance = compose(pure);

const button = enhance(({ classes, onClickAction, customStyles }) => {
  return (
    <Button
      variant="contained"
      color="primary"
      className={customStyles || classes.button}
      onClick={onClickAction}
    >
      検索
    </Button>
  );
});

export default withStyles(styles)(button);
